import { render, staticRenderFns } from "./BuyerRegistrationPageForm.vue?vue&type=template&id=1cef1bec"
import script from "./BuyerRegistrationPageForm.vue?vue&type=script&lang=js"
export * from "./BuyerRegistrationPageForm.vue?vue&type=script&lang=js"
import style0 from "./BuyerRegistrationPageForm.vue?vue&type=style&index=0&id=1cef1bec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports